// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"7470fa2d","147":"6e552360","453":"0daac03d","576":"0e0086ad","759":"68c3d007","780":"621d6594"}[chunkId] + ".chunk.js";
};